<template>
  <div class="page-container">
    <!-- 搜索栏 -->
    <div>
      <div>
        <div class="page-card__header">
          <el-row>
            <el-col :span="4">
              <span> 参观登记（共{{ aSum }}人）</span>
            </el-col>

            <el-col :span="2">
              <div>
                <el-button type="primary" @click="openAddWindow">添加登记</el-button>
              </div>
            </el-col>
            <el-col :span="2">
              <div>
                <el-button type="primary" @click="openAllWindow">批量添加号码</el-button>
              </div>
            </el-col>
            <el-col :span="6" :offset="10">
              <el-input v-model="input">
                <el-button slot="append" icon="el-icon-search" @click="serach"></el-button>
              </el-input>
            </el-col>
          </el-row>
        </div>
      </div>


      <!-- 数据表格 -->
      <el-table :data="tableData" style="width: 100%; padding: 0 20px">
        <el-table-column prop="id" label="ID" width="100"></el-table-column>

        <el-table-column prop="name" label="姓名" width="80"></el-table-column>

        <el-table-column prop="coname" label="公司名称"></el-table-column>

        <el-table-column prop="position" label="职务" width="90">
        </el-table-column>

        <el-table-column prop="mobile" label="电话" width="110">
        </el-table-column>

        <el-table-column prop="email" label="邮箱" width="120">
        </el-table-column>

        <el-table-column prop="interest" label="兴趣产品"></el-table-column>

        <el-table-column prop="purpose" label="产品用途"></el-table-column>

        <el-table-column prop="objective" label="参观目的"></el-table-column>

        <el-table-column prop="channel" label="获知渠道"></el-table-column>

        <el-table-column prop="visit_num" label="登记号码"></el-table-column>

        <el-table-column
          prop="create_time"
          label="时间"
          width="160"
          sortable
        ></el-table-column>

        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" class="action-btn--danger" @click="handleClick(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页器 -->
      <div class="pagination-wrap">
        <el-pagination
          @current-change="handleCurrentChange"
          :page-size="pagesize"
          :total="aSum"
          :page-count="pageCount"
          :current-page.sync="currentPage"
          background
          layout="prev, pager, next,jumper"
        >
        </el-pagination>
      </div>
    </div>

    <!-- 弹窗 - 添加参观商 -->
    <el-dialog
      title="添加参观商"
      :visible.sync="addTotalVisible"
      width="800px"
      :close-on-click-modal="false"
      style="text-align: center"
    >
      <el-form label-width="100px" ref="form" :model="form" :rules="rules">
        <el-row>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="手机号：" style="text-align: left" prop="mobile">
              <el-input v-model="form.mobile"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">

            <el-form-item label="姓名：" style="text-align: left" prop="name">
              <el-input v-model="form.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="公司名：" style="text-align: left" prop="coname">
              <el-input v-model="form.coname"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="职务：" style="text-align: left" prop="position">
              <el-input v-model="form.position"></el-input>
            </el-form-item>
          </el-col>
        </el-row>


        <el-form-item label="邮箱：" style="text-align: left" prop="email">
          <el-input v-model="form.email"></el-input>
        </el-form-item>

        <el-form-item label="公司性质：" style="text-align: left" prop="nature">
          <el-radio-group v-model="form.nature">
            <el-radio label="终端用户"></el-radio>
            <el-radio label="制造商"></el-radio>
            <el-radio label="经销商"></el-radio>
            <el-radio label="批发商"></el-radio>
            <el-radio label="代理商"></el-radio>
            <el-radio label="进口商"></el-radio>
            <el-radio label="出口商"></el-radio>
            <el-radio label="协会/组织"></el-radio>
            <el-radio label="媒体"></el-radio>
            <el-radio label="其他"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="产品用途：" style="text-align: left" prop="purpose">
          <el-checkbox-group v-model="productList" @change="interestChange">
            <el-checkbox label="螺栓"></el-checkbox>
            <el-checkbox label="螺母"></el-checkbox>
            <el-checkbox label="螺钉"></el-checkbox>
            <el-checkbox label="垫圈"></el-checkbox>
            <el-checkbox label="铆钉"></el-checkbox>
            <el-checkbox label="非标"></el-checkbox>
            <el-checkbox label="设备"></el-checkbox>
            <el-checkbox label="工模具"></el-checkbox>
            <el-checkbox label="表面处理"></el-checkbox>
            <el-checkbox label="原材料"></el-checkbox>
            <el-checkbox label="检测设备"></el-checkbox>
            <el-checkbox label="其他"></el-checkbox>
          </el-checkbox-group>

        </el-form-item>
        <el-form-item label="兴趣产品：" style="text-align: left" prop="interest">
          <el-checkbox-group v-model="purposeList" @change="purposeChange">
            <el-checkbox label="建筑"></el-checkbox>
            <el-checkbox label="电子电器"></el-checkbox>
            <el-checkbox label="汽车"></el-checkbox>
            <el-checkbox label="机械"></el-checkbox>
            <el-checkbox label="五金"></el-checkbox>
            <el-checkbox label="航空航天"></el-checkbox>
            <el-checkbox label="船舶"></el-checkbox>
            <el-checkbox label="轨道交通"></el-checkbox>
            <el-checkbox label="风电"></el-checkbox>
            <el-checkbox label="表面处理"></el-checkbox>
            <el-checkbox label="测控相关"></el-checkbox>
            <el-checkbox label="其他"></el-checkbox>

          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="参观目的：" style="text-align: left" prop="objective">
          <el-checkbox-group v-model="objectiveList" @change="objectiveChange">
            <el-checkbox label="购买现场产品"></el-checkbox>
            <el-checkbox label="寻找供货商"></el-checkbox>
            <el-checkbox label="了解行业信息"></el-checkbox>
            <el-checkbox label="为未来参展考虑"></el-checkbox>
            <el-checkbox label="其他"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="获知渠道：" style="text-align: left" prop="channel">
          <el-checkbox-group v-model="channelList" @change="channelChange">
            <el-checkbox label="官网"></el-checkbox>
            <el-checkbox label="媒体杂志"></el-checkbox>
            <el-checkbox label="协会邀请"></el-checkbox>
            <el-checkbox label="主办邀请"></el-checkbox>
            <el-checkbox label="朋友介绍"></el-checkbox>
            <el-checkbox label="搜索引擎"></el-checkbox>
            <el-checkbox label="其他网站"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <el-form-item style="text-align: right">
          <el-button type="primary" @click="submitAdd('form')">
            确认提交
          </el-button>

        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 弹窗 - 批量新增人员 -->
    <el-dialog
      title="批量新增人员"
      :visible.sync="dialogBatch"
      width="400px"
      :close-on-click-modal="closeOnClickModal"
    >

      <div>
        <div style="padding: 20px 0;font-size: 18px">
          上传的模板 <a href="https://cloudexhibition.oss-cn-shenzhen.aliyuncs.com/config/visits.xlsx"
                   style="color: #0836bf" target="_blank">下载</a>
        </div>
        <div style="padding: 20px 0">

          <el-upload
            :headers="headers"
            ref="upload"
            class="upload-demo"
            :file-list="fileList"
            :action="action"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
            :on-remove="handleRemove"
            :limit="1"
            :on-exceed="handleExceed"
            :on-error="handleError"
            :auto-upload="false"
            accept=".xlsx, .xlsm, .xls"
          >

            <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
          </el-upload>

        </div>
        <div style="margin-top: 20px">
          <el-button @click="dialogBatch = false">取 消</el-button>
          <el-button :loading="loading" type="primary" @click="submitUpload">上传文件</el-button>
        </div>
      </div>
    </el-dialog>
  </div>

</template>

<script>
  import api from "../../utils/api";

  export default {
    name: "viewerList",
    components: {
    },
    data() {
      var checkEmail = (rule, value, callback) => {//邮箱校验
        const mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
        if (!value) {
          callback()
        } else {
          setTimeout(() => {
            if (mailReg.test(value)) {
              callback()
            } else {
              callback(new Error('请输入正确的邮箱格式'))
            }
          }, 100)
        }

      }
      return {

        input: '',
        dialogBatch: false,
        closeOnClickModal: false,
        loading: false,

        tableData: [],

        headers: {"Authorization": "JWT " + localStorage.getItem('adminToken')},
        fileList: [],
        action: this.baseUrl + "/admin/visits_import/",

        //分页
        // 总条目数 total
        aSum: 0,
        // 当前页数 currenr_page
        currentPage: 1,
        // 总页数 num_pages
        pageCount: 1,
        // 每页显示条目数 pagesize
        pagesize: 10,

        //
        addTotalVisible: false,
        purposeList: [],
        objectiveList: [],
        channelList: [],
        productList: [],
        form: {
          mobile: "",
          name: "",
          coname: "",
          position: "",
          email: '',
          nature: '',
          purpose: '',
          interest: '',
          objective: '',
          channel: '',
        },
        rules: {
          mobile: [{required: true, message: "请输入手机号", trigger: "blur"}, {
            min: 11,
            max: 11,
            message: '手机号必须为11位',
            trigger: 'blur'
          }],
          name: [{required: true, message: "请输入名字", trigger: "blur"}],
          coname: [{required: true, message: "请输入公司名", trigger: "blur"}],
          position: [{required: true, message: "请输入职务", trigger: "blur"}],
          email: [{required: false, validator: checkEmail, trigger: 'blur'}],
        },

      };
    },
    mounted() {
      this.reserveList();
    },
    methods: {
      /** 获取参观登记列表数据 */
      reserveList() {
        let url = this.baseUrl + "/admin/visits/?ordering=-create_time";
        api.fetchData(url).then((res) => {
          this.tableData = res.results;
          this.aSum = res.count;
          this.currentPage = 1;
        });
      },

      /** 分页切换处理 */
      handleCurrentChange(val) {
        let url = this.baseUrl + "/admin/visits/?ordering=-create_time&page=" + val + '&search=' + this.input;
        api.fetchData(url).then((res) => {
          this.tableData = res.results;
          this.aSum = res.count;
          this.currentPage = val;
        });
      },

      /** 打开添加参观商弹窗 */
      openAddWindow() {
        this.addTotalVisible = true
      },

      /** 打开批量添加弹窗 */
      openAllWindow() {
        this.dialogBatch = true
      },

      /** 提交添加参观商表单 */
      submitAdd(formname) {
        this.$refs[formname].validate((valid) => {
          if (valid) {
            let url = this.baseUrl + "/admin/visits/";
            api.postData(url, this.form)
              .then((res) => {
                this.$message({
                  message: "资料登记成功",
                  type: "success",
                });
                this.form = {}
                this.purposeList = []
                this.objectiveList = []
                this.channelList = []
                this.productList = []
                this.updateTotalVisible = false;
                this.addTotalVisible = false
                this.reserveList();
              }, error => {
                this.$message({
                  message: error.response.data[0],
                  type: "warning",
                });
              })
          }
        })
      },


      /** 按关键词搜索参观登记 */
      serach() {
        let url = this.baseUrl + "/admin/visits/?ordering=-create_time&search=" + this.input;
        api.fetchData(url).then((res) => {
          this.tableData = res.results;
          this.aSum = res.count;
          this.currentPage = 1;
        });
      },


      /** 产品用途选项变更处理 */
      purposeChange(val) {
        let change = val.join(",")
        this.form.purpose = change
      },

      /** 兴趣产品选项变更处理 */
      interestChange(val) {
        let change = val.join(",")
        this.form.interest = change
      },

      /** 参观目的选项变更处理 */
      objectiveChange(val) {
        let change = val.join(",")
        this.form.objective = change
      },

      /** 获知渠道选项变更处理 */
      channelChange(val) {
        let change = val.join(",")
        this.form.channel = change
      },


      /** 上传失败回调 */
      handleError(err) {
        this.$message({
          message: '上传失败,请检查文档内容',
          type: 'warning'
        })
      },

      /** 超出文件数量限制回调 */
      handleExceed() {
        this.$message({
          message: '最多上传1文件',
          type: 'warning'
        })
      },

      /** 上传成功回调 */
      handleAvatarSuccess(res, file) {
        this.$message({
          message: res.detail + '，成功：' + res.success_num + ' ，忽略：' + res.fail_num,
          type: 'success'
        })
        this.fileList = []
        this.loading = false
        this.dialogBatch = false

      },

      /** 移除已选文件 */
      handleRemove(file) {
        const index = this.fileList.indexOf(file)
        if (index !== -1) {
          this.fileList.splice(index, 1)
        }

      },

      /** 上传前文件格式校验 */
      beforeAvatarUpload(file) {
        const isJPG = file.type === 'application/vnd.ms-excel' || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'

        if (!isJPG) {
          this.$message.error('上传文件只能是 xlsx 、xls格式!')
        }

        return isJPG
      },


      /** 触发文件上传 */
      submitUpload() {
        this.$refs.upload.submit()
        this.loading = true
      },

      /** 删除参观登记记录 */
      handleClick(row) {
        this.$confirm("将删除此条信息，是否继续", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          let a_id = row.id;
          let url = this.baseUrl + "/admin/visits/" + a_id + "/";
          api.deleteData(url).then((res) => {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.reserveList();
          });
        });
      },
    },
  };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/admin/viewerList.vue